import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'

export const toolTipContainer = {
    boxSizing: 'border-box',
    position: 'absolute',
    left: 0,
    top: pxToRem(32),
    width: '100%',
    background: 'white',
    border: `${pxToRem(1)} solid #ccc`,
    boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.3)',
    padding: pxToRem(10),
    borderTop: 'none',
    zIndex: 9999,

    p: {
        textAlign: 'left',
        margin: `0 0 ${pxToRem(10)}`,
        fontSize: pxToRem(12),
        lineHeight: pxToRem(24),
        paddingTop: pxToRem(5),
        letterSpacing: pxToRem(1)
    },

    span: {
        fontSize: pxToRem(20),
        cursor: 'pointer',
        float: 'right',
        paddingRight: pxToRem(10),
        lineHeight: 'normal'
    },

    a: {
        color: 'black',
        display: 'inline-block',
        marginTop: 0,
        marginRight: 0,
        padding: 0,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        fontFamily: fonts.primary,
        letterSpacing: pxToRem(3.12),
        fontSize: pxToRem(12)
    }
}

export const headerPromoContainer = {
    flex: 1,
    position: 'relative',
    width: '40%',

    p: {
        color: 'black'
    },
    '.slick-dots': {
        position: 'absolute',
        top: pxToRem(7),
        right: pxToRem(1),
        display: 'flex !important',
        justifyContent: 'flex-end',
        width: 'auto !important',
        background: 'var(--chakra-colors-whiteAlpha-800)',
        bottom: 0,
        height: 'inherit',

        li: {
            width: pxToRem(8),
            height: pxToRem(8),
            top: pxToRem(0)
        },

        'li button:before': {
            borderRadius: '100%',
            color: 'black',
            backgroundColor: 'black',
            fontSize: 0,
            lineHeight: 0,
            position: 'absolute',
            top: 0,
            transform: 'translateY(-50%)',
            right: pxToRem(0),
            width: pxToRem(8),
            height: pxToRem(8),
            textAlign: 'center',
            margin: '0 5px',
            opacity: '1'
        },
        'li.slick-active button:before': {
            backgroundColor: 'cav_calltoaction_darkred',
            color: 'cav_calltoaction_darkred'
        }
    },
    '#homepage-slides': {
        p: {
            cursor: 'pointer'
        }
    }
}

export const topArrowStyle = {
    width: 0,
    height: 0,
    borderLeft: `${pxToRem(10)} solid transparent`,
    borderRight: `${pxToRem(10)} solid transparent`,
    borderTop: 0,
    borderBottom: `${pxToRem(7)} solid white`,
    position: 'absolute',
    right: 0,
    top: pxToRem(-9)
}
